import { Component, inject } from '@angular/core';
import { Api } from '../../services/api';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MdlDelete } from '../../components/mdl-delete/mdl-delete';
import { MdlManageContact } from '../../components/mdl-manage-contact/mdl-manage-contact';
import { MdlContactFunction } from '../../components/mdl-contact-function/mdl-contact-function';

@Component({
  selector: 'app-nav-functiondetailtable',
  imports: [CommonModule],
  templateUrl: './function-detail-table.html',
  styleUrl: './function-detail-table.css'
})
export class FunctionDetailTable {
  public oportunidad_id: string = '';
  public api = inject(Api);
  public contactos: any = [];
  readonly dialog = inject(MatDialog);

  openedMenuId: string | null = null;
  showRecentDropdown: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
      this.route.params.subscribe(params => {
      this.oportunidad_id = params['id'];
      console.log(this.oportunidad_id);

      this.getContactFunctions(this.oportunidad_id);
    });
  }

  getContactFunctions(oportunidad_id: string){
    this.api.getContactFunctions({oportunidad_id:oportunidad_id}).subscribe({
      next: (data:any)=>{
        this.contactos = data.contactos;
      }, 
      error: (err:any)=>{
        console.error(err);
      }
    })
  }

  toggleActionsMenu(id: string): void {
    console.log("Click");
    this.openedMenuId = this.openedMenuId === id ? null : id;
    this.showRecentDropdown = false; 
  }

  openMdlDeleteContact(id: string) {
    this.dialog.open(MdlDelete, {
      minWidth: '500px',
      minHeight: '260px',
      panelClass: 'mat-dlg-class',
      data:{
        mode: 'contact',
        id: id
      }
    })
  }

  openMdlAddFunction() {
    this.dialog.open(MdlContactFunction, {
      minWidth: '800px',
      minHeight: '260px',
      panelClass: 'mat-dlg-class',
      data:{
        mode: 'add'
      }
    })
  }

  updateContact(data:any){
    console.log("Click");
    this.dialog.open(MdlManageContact,{
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data:{
        mode: 'edit',
        contact: data
      }
    })
  }
}